import React, { ChangeEvent, useState } from 'react'
import { Grid, Typography } from "@mui/material"
import AttachFileIcon from '@mui/icons-material/AttachFile'
import { useDispatch } from 'react-redux'
import { setTab } from '../TasksList/tasks-reducer'
import moment from 'moment'
import { TaskStateType, WorkItemType } from '../../api/projects-api'

type GreySectionPropsType = {
  item: WorkItemType
  attachmentsCount: number | string
  openedTab: string
  setTaskStateInParent: (taskState: TaskStateType) => void
}

export const GreySection = (props: GreySectionPropsType) => {

  const dispatch = useDispatch()
  const [taskState, setTaskState] = useState(props.item.fields?.["System.State"])

  let taskStateOption
  props.item.fields?.["System.State"] === 'Resolved' ? taskStateOption = 'Closed' :
  props.item.fields?.["System.State"] === 'Closed' ? taskStateOption = 'Active' : taskStateOption = ''

  let stateColor: string = 'rgb(178, 178, 178)'
  if (taskState === 'Active') {
    stateColor = 'rgb(0, 122, 204)'
  } else if (taskState === 'Resolved') {
      stateColor = 'rgb(255, 157, 0)'
    } else if (taskState === 'Closed'){
      stateColor = 'rgb(51, 153, 51)'
  }

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    
    if (event.target.value) {
      let newState = event.target.value as TaskStateType
      setTaskState(newState)
      props.setTaskStateInParent(newState)
    }
  }

  return (
    <Grid className='itemInfo' container >
    <Grid item md={1} xs={6}>
      <Typography variant="caption" style={{ color: 'grey' }}>
        Statu<u>s</u> {' '}
      </Typography>
      <div>
        <Typography variant="caption" style={{ color: 'grey' }}>
          Pri<u>o</u>rity {' '}
        </Typography>
      </div>
    </Grid>
      <Grid item md={2} xs={6} >
        <Typography variant="body2" style={{ display: 'inline-flex', alignItems: 'center' }}>
          <div style={{
            border: ' 1px solid', marginRight: '10px', width: '11px', height: '11px', backgroundColor: stateColor, borderRadius: '50%',
            borderColor: stateColor
          }}></div>
          {taskStateOption === '' ? taskState :  
          <select value={taskState} onChange={(e) => handleChange(e)} id='taskState'>
            <option value={props.item.fields?.["System.State"]}>{props.item.fields?.["System.State"]}</option>
            <option value={taskStateOption}>{taskStateOption}</option>
          </select>}
        </Typography>
        <Typography style={{marginTop:'5px'}} variant="body2">
          {props.item.fields?.["Microsoft.VSTS.Common.Priority"]}
        </Typography>
      </Grid>
    <Grid item md={1} xs={6}>
      <Typography variant="caption" style={{ color: 'grey' }}>
        <u>A</u>rea {' '}
      </Typography>
      <Typography>
      </Typography>
    </Grid>
    <Grid item md={2} xs={6}>
      <Typography variant="body2">
        {props.item.fields?.["System.AreaPath"]}
      </Typography>
      <Typography>
      </Typography>
    </Grid>
    <Grid item md={6} xs={6}>
      <Typography variant="caption" style={{ float: 'right', color: 'grey' }}>
        {/* Updated by {props.item.fields?.['System.ChangedBy']?.displayName}: */}
        Updated: 
          {moment(props.item.fields?.['System.ChangedDate']).locale('de').format('DD.MM.YYYY')}
      </Typography>
    </Grid>
    <Grid className='itemInfoDetails' container >
      <Grid onClick={() => dispatch(setTab ({ tabName: 'details' }))} item className={props.openedTab === 'details' ? 'details detailsActive' : 'details'}  >
        Details
      </Grid>
      <Grid onClick={() => dispatch(setTab({ tabName: 'attachments' }))} item className={props.openedTab === 'attachments' ? 'details detailsActive' : 'details'} >
        <AttachFileIcon fontSize="small" />
        <span style={{ fontSize: '14px' }}>
          {props.attachmentsCount}
        </span>
      </Grid>
    </Grid>
  </Grid>
  )
}